import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteComponent from "../../../Components/Common/deleteComponent/DeleteComponent";
import { getPersonalDetails } from "../../../helpers/urlConfig/apiFunctions";
import PersonalDetailsEdit from "./PersonalDetailsEdit";
import PersonalDetailsCreate from "./PersonalDetailsCreate";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { documentTitle } from "../../../helpers/documentTitle";
import errorResponseHandler from "../../../helpers/errorResponseHandler";

const PersonalDetailsList = () => {
  const [modal_list, setmodal_list] = useState(false);
  const [modal_delete, setmodal_delete] = useState(false);
  const [edit_modal_list, set_edit_modal_list] = useState(false);
  const [editPersonalData, setEditPersonalData] = useState(null);
  const [deleteId, setDeleteProductId] = useState(null);

  const [personalDetails, setPersonalDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // Add loading state

  const tog_list = () => setmodal_list(!modal_list);
  const edit_tog_list = () => set_edit_modal_list(!edit_modal_list);
  const tog_delete = () => setmodal_delete(!modal_delete);

  documentTitle("Personal Details");

  const fetchData = async () => {
    setIsLoading(true); // Set loading to true while fetching
    try {
      const response = await getPersonalDetails();

      if (response.statusCode === 200) {
        setPersonalDetails(response.data);
        sessionStorage.setItem("logo", response.data[0].logo);
      } else {
        errorResponseHandler(response);
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsLoading(false); // Set loading to false after fetch
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleEditChanges = (data) => {
    setEditPersonalData(data);
    edit_tog_list();
  };

  const onClickRemoveBtn = (id) => {
    setDeleteProductId(id);
    tog_delete();
  };

  const renderSkeletonRow = () => (
    <tr>
      {Array.from({ length: 7 }).map((_, index) => (
        <td key={index}>
          <Skeleton height={20} />
        </td>
      ))}
    </tr>
  );
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Personal Details List"
            pageTitle="Personal Details"
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div id="customerList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm-auto">
                        {personalDetails.length === 0 ? (
                          <div>
                            <Button
                              color="success"
                              className="add-btn me-1"
                              onClick={tog_list}
                              id="create-btn"
                            >
                              <i className="ri-add-line align-bottom me-1"></i>{" "}
                              Add Personal Detail
                            </Button>
                          </div>
                        ) : (
                          <div>
                            <Button
                              color="success"
                              className="add-btn me-1"
                              onClick={tog_list}
                              id="create-btn"
                              disabled
                            >
                              <i className="ri-add-line align-bottom me-1"></i>{" "}
                              Add Personal Detail
                            </Button>
                          </div>
                        )}
                      </Col>
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                            />
                            <i className="ri-search-line search-icon"></i>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <div className="table-responsive table-card mt-3 mb-1">
                      <table className="table align-middle table-nowrap">
                        <thead className="table-light">
                          <tr>
                            <th>SL.No</th>
                            <th>Owner Name</th>
                            <th>Bank Name</th>
                            <th>Account Number</th>
                            <th>IFSC Code</th>
                            <th>Branch</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading
                            ? Array.from({ length: 5 }).map((_, index) =>
                                renderSkeletonRow()
                              )
                            : personalDetails.map((details, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{details.name}</td>
                                  <td>{details.bank}</td>
                                  <td>{details.acc_no}</td>
                                  <td>{details.ifsc_code}</td>
                                  <td>{details.branch}</td>
                                  <td>
                                    <div className="d-flex gap-2">
                                      <div className="edit">
                                        <button
                                          className="btn btn-sm btn-success"
                                          onClick={() =>
                                            handleEditChanges(details)
                                          }
                                        >
                                          Edit
                                        </button>
                                      </div>
                                      <div className="remove">
                                        <button
                                          className="btn btn-sm btn-danger"
                                          onClick={() =>
                                            onClickRemoveBtn(details.id)
                                          }
                                        >
                                          Remove
                                        </button>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                        </tbody>
                      </table>
                      {!isLoading && personalDetails.length === 0 && (
                        <div className="text-center mt-4">
                          <p>No Personal Details found.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <PersonalDetailsCreate
        modal_list={modal_list}
        setmodal_list={setmodal_list}
        tog_list={tog_list}
        fetchData={fetchData}
      />

      {edit_modal_list && (
        <PersonalDetailsEdit
          modal_list={edit_modal_list}
          setmodal_list={set_edit_modal_list}
          tog_list={edit_tog_list}
          editPersonalData={editPersonalData}
          fetchData={fetchData}
        />
      )}

      {/* Delete Confirmation Modal */}
      <DeleteComponent
        modal_delete={modal_delete}
        tog_delete={tog_delete}
        fetchData={fetchData}
        deleteId={deleteId}
        keyName="PersonalDetails"
      />
    </React.Fragment>
  );
};

export default PersonalDetailsList;
